import Api from '@sendsprint/api-types';
import { IMAGE_SUPPORTED_FORMATS, TWO_MB } from '@src/constants';
import { phoneSchemaFactory, Shape } from '@src/validations';
import * as yup from 'yup';
import { BusinessInformationFormData } from '../components/businessInformationStep';
import { getSentenceWords } from '@src/utils/getSentenceWords';

interface GetBusinessInformationOptions {
  businessCountry: Api.Model.CountryInitials | undefined;
}

export const getBusinessInformationSchema = ({ businessCountry }: GetBusinessInformationOptions) =>
  yup.object().shape<Shape<BusinessInformationFormData>>({
    typeOfBusiness: yup.string().required('Please select business type'),
    tradeName: yup.string(),
    companyWebsiteUrl: yup.string().required('Please enter company website url'),
    companyRegistrationNumber: yup.string().required('Please enter company registration number'),
    taxIdentificationNumber: yup.string().required('Please enter tax identification number'),
    businessDescription: yup
      .string()
      .required('Please enter business description')
      .test('NUMBER_OF_WORDS', 'Business description should be more than 10 words', (value) => {
        if (value) {
          const numberOfWords = getSentenceWords(value);

          if (numberOfWords && numberOfWords < 10) {
            return false;
          }
        }

        return true;
      }),
    useRegisteredAddress: yup.boolean(),
    addressInfo: yup
      .array()
      .of(
        yup.object().shape({
          address: yup.string().required('Please enter address'),
          city: yup.string().required('Please enter city'),
          state: yup.string().required('Please select state'),
          zipCode: yup.string().required('Please enter zip code')
          // registeredAddressEvidence: yup
          //   .mixed()
          //   .nullable()
          //   .required('Please upload evidence of registered address')
          //   .test('FILE_FORMAT', 'Supported formats: jpeg, jpg, png', (value) => {
          //     if (value && typeof value !== 'string') {
          //       return ['image/jpeg', 'image/png', 'image/jpg'].includes(value.type);
          //     }
          //     return true;
          //   })
          //   .test('FILE_SIZE', 'File too big. Maximum of 2mb', (value) => {
          //     if (value && typeof value !== 'string') {
          //       return value.size <= 2 * 1024 * 1024;
          //     }
          //     return true;
          //   })
        })
      )
      .min(1, 'At least one address is required'),
    businessEmailAddress: yup
      .string()
      .email('Please enter a valid email')
      .required('Please enter business email address'),
    businessIndustry: yup.string().required('Please select business industry'),
    businessName: yup.string().required('Please enter business name'),
    businessPhoneNumber: phoneSchemaFactory({
      countryCodeOrPath: businessCountry || '',
      required: true,
      numbersOnly: true
    }),
    logo: yup
      .mixed()
      .nullable()
      .required('Please add logo')
      .test(
        'FILE_FORMAT',
        'Please check the format of the files selected. The supported formats are jpeg, jpg or png.',
        (value) => {
          if (typeof value === 'string') {
            return true;
          }

          if (value) {
            if (!IMAGE_SUPPORTED_FORMATS.includes(value?.type)) {
              return false;
            }
          }

          return true;
        }
      )
      .test('FILE_SIZE', 'File too big. Maximum of 2mb', (value) => {
        if (typeof value === 'string') {
          return true;
        }

        if (value) {
          if (value.size > TWO_MB) {
            return false;
          }
        }

        return true;
      })
  });
